<template>
  <div class="w-full">
    <UInputMenu
      v-model="_value"
      :items="segments"
      label-key="name"
      :filter-fields="['name', 'shortName']"
      :placeholder="$t('components.segments.elements.select.placeholder')"
      :multiple="isMulti || undefined"
      :by="compareSegments"
    >
      <template #item="{ item }">
        {{ item.name }}
      </template>
    </UInputMenu>
  </div>
</template>

<script setup lang="ts">
import { useSegmentStore } from '~/stores/useSegmentStore'

interface Props {
  modelValue?: any
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const segmentStore = useSegmentStore()

const _value = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

const segments = computed(() => segmentStore.all)

const isMulti = computed(() => {
  return props.modelValue && Array.isArray(props.modelValue)
})

const compareSegments = (a: any, b: any) => {
  if (!a || !b) return false
  if (a.idSegment && b.idSegment) return Number(a.idSegment) === Number(b.idSegment)
  return a === b
}
</script>
